export default {
  init() {
    // JavaScript to be fired on all pages
    
    document.cookie = 'same-site-cookie=foo; SameSite=Lax';
    document.cookie = 'cross-site-cookie=bar; SameSite=None; Secure';

    $('.my-slider, .testimonials').slick({
      dots: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      arrows:false,
      autoplay: true,
      speed: 3000,
      autoplaySpeed: 3000,
    });

    $(window).scroll(function(){
       const $header = $('header');
       let number = 0;
       // effet nav qui change de couleur en-dessous dès qu'il dépasse le header

       $('.wrap-nav').toggleClass('scrolled', $(this).scrollTop() > $header.height());

       $('.wrap-nav .sub-menu').toggleClass('scrolled-submenu', $(this).scrollTop() > $header.height());
    });

    $('#nav-toggle').click(function(){
        $('#nav-menu-mobile').toggleClass('open-menu', 1000, 'easeOutSine')
    });
     
    $('#nav-toggle').on('click', function() {
           $(this).classList.toggle('active');
       });

    $('#accordionExample .faq-click').on('click', function() {
      $(this).find('svg').toggleClass('fa-plus-circle fa-minus-circle');
    });

    $('#accordionExample .collapse').on('click', function() {
       $(this).toggleClass('show');

    });

    

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    const AOS = require('aos');
    AOS.init({
        disable: 'mobile'
    });
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js